import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GuidanceContent {
  flyerGuide?: any[];
  offersGuide?: any[];
  searchGuide?: any[];
  startButtonText?: string;
  skipButtonText?: string;
  prevButtonText?: string;
  nextButtonText?: string;
  closeButtonText?: string;
  isActive?: boolean;
  [key: string]: unknown;
}

export const guidanceSlice = createSlice({
  name: "guidanceAemContent",
  initialState: {
    guidanceContent: {} as GuidanceContent,
  },
  reducers: {
    setGuidanceContent(state, action: PayloadAction<GuidanceContent>) {
      state.guidanceContent = action.payload;
    },
  },
});

// Export actions and reducer for selected store
export const { setGuidanceContent } = guidanceSlice.actions;
export const guidanceAemReducer = guidanceSlice.reducer;
